import { defineAsyncComponent } from 'vue'
import type { ModuleConfig } from '@bridge2ai/core/frontend'
import emsQuoteIconUrl from './assets/ems-quote.svg'

// Foreseeson's own EMS Quote (moved from Core 2026-10-14). A new id: Core's registry resolves Core ids first, so the
// tenant cannot reuse `emsQuote`; moduleId/slug stay `ems-quote` so permissions and URLs are unchanged.
export const fssQuoteModule: ModuleConfig = {
  id: 'fssQuote',
  moduleId: 'ems-quote',
  slug: 'ems-quote',
  name: 'EMS Quote',
  iconUrl: emsQuoteIconUrl,
  componentLoader: () => defineAsyncComponent({ loader: () => import('./components/EMSQuoteApp.vue'), delay: 200, timeout: 10000 }),
}
